// Mirrors the server-side password policy (FacilityFinder-Server utils/passwordPolicy.js).
// The server additionally checks a weak-password blocklist; those errors come back
// as 400 { errors: [...] } and are surfaced by each form.
export const passwordRules = [
  { label: 'At least 8 characters', test: (password) => password.length >= 8 },
  { label: 'One uppercase letter', test: (password) => /[A-Z]/.test(password) },
  { label: 'One lowercase letter', test: (password) => /[a-z]/.test(password) },
  { label: 'One number', test: (password) => /[0-9]/.test(password) },
  { label: 'One special character', test: (password) => /[^A-Za-z0-9]/.test(password) },
];

export function validatePassword(password = '') {
  return passwordRules.every((rule) => rule.test(password));
}
